import {
  Arrange,
  Button,
  Icon,
  Modal,
  Spacer,
  SvgSparkle,
  Text,
  TextButton,
} from '@loomhq/lens';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  updateFillerWordHighlight,
  updateIsFillerRemovalFTUX,
} from 'actions/videoPlayer';
import { FILLER_REMOVAL_FTUX_CLICK } from 'constants/events';
import { SHOW_FIRST_FILLER_REMOVAL_EXPERIENCE } from 'constants/triggers';
import { handleToggleTranscriptCreator } from 'creators/shareVideo';
import * as analytics from 'utilities/analytics';
import { setShowReviewTranscriptButtonHightlight } from 'utilities/localStorage';

import FtuxDetector from 'components/ftux/ftux-detector';

import styles from './styles.module.less';

export default function FillerRemovalModal() {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(true);

  const closeModal = (endFtux, tryItOutCallback) => {
    let clickType = 'Go to my video';

    endFtux();

    setIsOpen(!isOpen);
    dispatch(updateIsFillerRemovalFTUX(true));
    dispatch(updateFillerWordHighlight(true));

    if (tryItOutCallback) {
      tryItOutCallback();
      clickType = 'Try it out';
    } else {
      setShowReviewTranscriptButtonHightlight(true);
    }

    analytics.track(FILLER_REMOVAL_FTUX_CLICK, {
      clickType,
    });
  };

  const tryItOut = () => {
    dispatch(handleToggleTranscriptCreator());
  };

  return (
    <FtuxDetector
      triggerKey={SHOW_FIRST_FILLER_REMOVAL_EXPERIENCE}
      launchDate={'2021-05-16'}
      maxDuration={{ weeks: 3 }}
    >
      {({ ftuxEnabled, endFtux }) =>
        ftuxEnabled && (
          <Modal
            title={
              <Arrange
                alignItems="center"
                justifyContent="center"
                minWidth="408px"
                gap="small"
              >
                <Icon color="blue" icon={<SvgSparkle />} />
                <Text size="xlarge" fontWeight="bold">
                  New! Magically remove filler words
                </Text>
              </Arrange>
            }
            isOpen={isOpen}
            onCloseClick={() => closeModal(endFtux)}
            onBackgroundClick={() => closeModal(endFtux)}
          >
            <div className="px:medium">
              <Arrange autoFlow="row" justifyContent="stretch">
                <Text alignment="center">
                  Give your video a quick touch-up by eliminating
                  &lsquo;ums&rsquo; and &lsquo;uhs&rsquo; from the transcript,
                  closed captions, and audio (beta).
                </Text>
                <Spacer bottom={3} />
                <iframe
                  src="https://www.loom.com/embed/ced45f5bf50441ed8aaf093f3cc86bb9?hideEmbedTopBar=true"
                  frameBorder="0"
                  webkitallowfullscreen="true"
                  mozallowfullscreen="true"
                  allowFullScreen={true}
                  className={styles.fillerWordRemovalTutorial}
                ></iframe>
                <Spacer bottom={2} />
                <Button
                  size="large"
                  hasFullWidth
                  variant="primary"
                  onClick={() => closeModal(endFtux, tryItOut)}
                >
                  Try it out
                </Button>
                <Spacer bottom={2} />
                <div className="flex justify:center">
                  <TextButton onClick={() => closeModal(endFtux)}>
                    Go to my video
                  </TextButton>
                </div>
              </Arrange>
            </div>
          </Modal>
        )
      }
    </FtuxDetector>
  );
}
